import { normalizeSelectValues } from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import {
  CAP_ALERT_MESSAGE_TYPE,
  IPAWS_PROFILE_CODE,
  scopeOptions,
  statusOptions,
} from '../../config/Ipaws.config';
import IpawsSelectField from '../IpawsSelectField/IpawsSelectField';
import IpawsTextField from '../IpawsTextField/IpawsTextField';

const IpawsMessageHandlingSection = ({
  draft,
  findings,
  contractOptions,
  onDraftChange,
  onTextChange,
  statusHelp = null,
}) => {
  const handleScopeChange = (option) => {
    const scope = option?.value ?? '';
    const selectedResponseTypes = normalizeSelectValues(draft.responseType);

    onDraftChange({
      scope,
      restriction: scope === 'Restricted' ? draft.restriction : '',
      addresses: scope === 'Private' ? draft.addresses : '',
      responseType:
        scope === 'Public'
          ? selectedResponseTypes.filter((responseType) => responseType !== 'Assess')
          : selectedResponseTypes,
    });
  };

  return (
    <fieldset className="alert-creator-section alert-creator-section-ipaws ipaws-message-handling border rounded-3 p-3 shadow-sm">
      <legend className="alert-creator-section-title d-flex align-items-center">
        CAP message handling
      </legend>

      <div className="alert-creator-grid">
        {/* The operator picks the status. A new draft starts as Test; Actual is the public send
            (restored 2026-09-25 — a894fd93e had made this read-only, so Actual could not be
            selected; the channel rules run only for Actual). */}
        <IpawsSelectField
          inputId="ipaws-alert-status"
          fieldPath="status"
          label="Status *"
          options={contractOptions?.status ?? statusOptions}
          value={draft.status}
          onChange={(option) => onDraftChange({ status: option?.value ?? '' })}
          findings={findings}
          required
          wrapperClassName="alert-creator-select flex-grow-full"
        />

        <IpawsSelectField
          inputId="ipaws-alert-scope"
          fieldPath="scope"
          label="Scope *"
          options={contractOptions?.scope ?? scopeOptions}
          value={draft.scope}
          onChange={handleScopeChange}
          findings={findings}
          required
          wrapperClassName="alert-creator-select flex-grow-full"
        />
      </div>

      {/* Optional status help from the workflow. The Global Action editor uses it. */}
      {statusHelp}

      {draft.scope === 'Restricted' && (
        <IpawsTextField
          controlId="ipaws-alert-restriction"
          fieldPath="restriction"
          label="Distribution restriction"
          value={draft.restriction}
          onChange={onTextChange}
          findings={findings}
          required
        />
      )}

      {draft.scope === 'Private' && (
        <IpawsTextField
          controlId="ipaws-alert-addresses"
          fieldPath="addresses"
          label="Private recipients"
          value={draft.addresses}
          onChange={onTextChange}
          findings={findings}
          placeholder={'Separate recipients with spaces; quote names like "County Operations"'}
          as="textarea"
          required
        />
      )}

      <div className="alert-creator-readonly-info border rounded-3 p-3">
        <dl className="d-grid gap-1 mb-0">
          <div className="d-flex justify-content-between gap-3">
            <dt>Message type</dt>
            <dd className="mb-0">{draft.messageType ?? CAP_ALERT_MESSAGE_TYPE}</dd>
          </div>
          <div className="d-flex justify-content-between gap-3">
            <dt>IPAWS profile</dt>
            <dd className="mb-0">{IPAWS_PROFILE_CODE}</dd>
          </div>
        </dl>
      </div>
    </fieldset>
  );
};

export default IpawsMessageHandlingSection;
